// extracted by mini-css-extract-plugin
export default {"post":"ReadingListItem_post__R81nw","post-meta":"ReadingListItem_post-meta__eaiZZ","post-link":"ReadingListItem_post-link__hm32R","divider":"ReadingListItem_divider__7g4pM"};